export const MALEK_CART_ITEMS_KEY = "malekstore_cart_items";
export const MALEK_STORE_TOKEN_KEY = "mk_store_tk";
export const MALEK_USERNAME_KEY = "mk_store_username";
export const MALEK_WISHLIST_KEY = 'mk_store_wishlist';
export const WEBSITE_GUEST_WISHLIST_KEY = "website_guest_wishlist";
export const MALEK_PENDING_VERIFICATION_KEY = "mk_pending_verification";
export const MALEK_VERIFICATION_DEVICE_KEY = "mk_verification_device";
export const MALEK_APP_PROMO_KEY = "mk_app_promo";
